module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./BarChart.js"));
	}, "BarChart");
}